/*
 * Copyright (c) 2020. Dave van Rijn Development
 */

import {FetchMethod} from '@dvrd/fetch';

export const URLS = {
    [FetchMethod.GET]: {
        USER: '/user/get',
        LOGOUT: '/auth/logout',
        DISABLE_TWO_FACTOR: '',
        GENERATE_TWO_FACTOR: '',
        DOWNLOAD_DOCUMENT: '/document/download/{document_id}',
        CALENDAR_EVENTS: '/calendar/events',
    },
    [FetchMethod.POST]: {
        LOGIN: '/auth/login',
        USER: '',
        VALIDATE_TWO_FACTOR: '',
        REGISTER: '',
        GET_NAV_BLOCKS: '/nav-block/all',
        SET_NAV_BLOCKS: '/nav-block/set',
        GET_DOCUMENTS: '/document/all',
        LOAD_CONTENT: '/content/load',
        PUBLISH_CONTENT: '/content/publish',
        GET_CALENDAR_ITEMS: '/calendar-items/all',
        CONTACT_REQUEST: '/contact/contact',
        REGISTER_REQUEST: '/contact/registration',
        UPLOAD_DOCUMENT: '/document/upload'
    },
    [FetchMethod.PUT]: {
        USER: '',
        UPDATE_CONTENT: '/content/update',
        UPDATE_DOCUMENT: '/document/update'
    },
    [FetchMethod.DELETE]: {
        USER: '',
        DELETE_DOCUMENT: '/document/delete/{document_id}',
    }
};

export const createParamUrl = (url: string, params: Record<string, string | number>) => {
    const keys = Object.keys(params);
    for (const key of keys)
        url = url.replace(`{${key}}`, params[key].toString());
    return url;
};